module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (170).b4c7c72a.jpg";